<template>
    <div class="step step-3 flex flex-col items-center w-full top-0 bottom-0">
        <h2 class="subtitle white text-center mt-5">
            {{ $trans.get("deposits.step-3-subtitle") }}
        </h2>

        <div class="summary-box p-5">
            <div class="pb-3 mb-5">
                <p class="title">
                    {{ $trans.get("deposits.title-selection") }}
                </p>
                <p>{{ titleSelected }}</p>
            </div>
            <p class="title">{{ $trans.get("deposits.summary") }}:</p>
            <ul>
                <li v-if="['title', 'title+taxes'].includes(purpose)">
                    <span class="material-icons material-icons-circle pr-1">
                        circle
                    </span>
                    <p class="inline">
                        {{ $trans.get("deposits.step-2-options.title") }}
                    </p>
                </li>
                <li v-if="['taxes', 'title+taxes'].includes(purpose)">
                    <span class="material-icons material-icons-circle pr-1">
                        circle
                    </span>
                    <p class="inline">
                        {{ $trans.get("deposits.step-2-options.taxes") }}
                    </p>
                </li>
            </ul>
        </div>

        <div
            class="bottom self-stretch flex flex-col items-center mt-8 pt-8 mx-auto"
        >
            <p>{{ $trans.get("deposits.enter-amount") }}</p>
            <div
                class="flex flex-col space-y-4 md:flex-row md:space-y-0 md:space-x-4"
            >
                <div v-if="['title', 'title+taxes'].includes(purpose)">
                    <label class="block ml-1 mb-3" for="titleAmount">{{
                        $trans.get("deposits.titleName")
                    }}</label>

                    <div class="relative flex justify-center items-center">
                        <input
                            class="w-full h-full"
                            type="text"
                            id="titleAmount"
                            v-model="titleAmount"
                            v-bind="money"
                            @keypress="checkIfNumeric($event)"
                        />
                        <svg
                            width="19px"
                            height="24px"
                            viewBox="0 0 19 24"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            class="euro-icon"
                        >
                            <title>€</title>
                            <g
                                id="Page-1"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                                font-family="Aktiv-Extended"
                                font-size="30"
                                font-weight="bold"
                                line-spacing="40"
                            >
                                <g
                                    id="ingresar-dinero-1"
                                    transform="translate(-1165.000000, -705.000000)"
                                    fill="#000"
                                >
                                    <text id="€">
                                        <tspan x="1165.20881" y="726">€</tspan>
                                    </text>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
                <div v-if="['taxes', 'title+taxes'].includes(purpose)">
                    <label class="block ml-1 mb-3" for="taxesAmount">{{
                        $trans.get("deposits.tax")
                    }}</label>
                    <div class="relative flex justify-center items-center">
                        <input
                            class="w-full h-full"
                            type="text"
                            id="taxesAmount"
                            v-model="taxesAmount"
                            v-bind="money"
                            @keypress="checkIfNumeric($event)"
                        />
                        <svg
                            width="19px"
                            height="24px"
                            viewBox="0 0 19 24"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            class="euro-icon"
                        >
                            <title>€</title>
                            <g
                                id="Page-1"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                                font-family="Aktiv-Extended"
                                font-size="30"
                                font-weight="bold"
                                line-spacing="40"
                            >
                                <g
                                    id="ingresar-dinero-1"
                                    transform="translate(-1165.000000, -705.000000)"
                                    fill="#000"
                                >
                                    <text id="€">
                                        <tspan x="1165.20881" y="726">€</tspan>
                                    </text>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <button
            class="mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated flex justify-between items-center mt-8"
            :disabled="buttonIsDisabled"
            @click="$emit('update:current-step', 4)"
        >
            <span class="mdc-button__label -mr-1 ml-6">{{
                $trans.get("deposits.next")
            }}</span>
            <span class="material-icons">keyboard_arrow_right</span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        titleSelected: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "(prefix any thing) ",
                suffix: " $",
                precision: 2,
                masked: false
            }
        };
    },
    computed: {
        ...mapGetters(["getFormData"]),
        purpose() {
            return this.getFormData.purpose;
        },
        titleAmount: {
            get() {
                return this.getFormData.titleAmount;
            },
            set(value) {
                this.setAmount("titleAmount", value);
            }
        },
        taxesAmount: {
            get() {
                return this.getFormData.taxesAmount;
            },
            set(value) {
                this.setAmount("taxesAmount", value);
            }
        },
        buttonIsDisabled() {
            let props,
                valid = true;
            switch (this.getFormData.purpose) {
                case "title":
                    props = ["titleAmount"];
                    break;
                case "taxes":
                    props = ["taxesAmount"];
                    break;
                case "title+taxes":
                    props = ["titleAmount", "taxesAmount"];
                    break;
            }
            for (let prop of props) {
                const value = this.getFormData[prop];
                if (!/^((\d+)|(\d+,\d{1,2}))$/g.test(value)) {
                    valid = false;
                }
            }
            return !valid;
        }
    },

    methods: {
        checkIfNumeric(e) {
            const k = e.keyCode;
            if (
                !(
                    [8, 9, 35, 36, 37, 39, 44, 110, 190].includes(k) ||
                    (k >= 48 && k <= 57)
                )
            ) {
                e.preventDefault();
            }
            if (k === 13) {
                this.$el.querySelector("button").click();
            }
        },
        setAmount(param, value) {
            this.$store.commit("setParamFromFormData", { param, value });
        }
    }
};
</script>

<style scoped lang="scss">
.summary-box {
    padding: 25px 24px 21px 19px;
    border-radius: 6px;
    background: #ff717d;
    color: white;

    p {
        margin-bottom: 0.5rem !important;
    }

    .title {
        font-size: 15px !important;
        line-height: 1.33;
    }

    p:not(.title) {
        font-size: 18px;
        font-weight: bold;
        line-height: 1.11;
    }

    div:first-child {
        border-bottom: 1px solid #ffd8db;
    }

    ul {
        padding-left: 12px !important;
    }
}

.bottom {
    border-top: 1px solid white;
    max-width: 385px;

    p {
        font-size: 20px;
        font-weight: bold;
        line-height: 2;
    }

    label {
        font-size: 14px;
        line-height: 1.14;
        margin-bottom: 6px;
    }

    input {
        background-color: white;
        width: 182px;
        height: 50px;
        padding: 10px 35px 10px 18px;
        border-radius: 6px;
        font-size: 22px;
        color: black;
        font-weight: bold;
        font-family: Aktiv-Extended;
        text-align: center;
    }
}

button {
    width: 152px;
}

.euro-icon {
    position: absolute;
    right: 0.75rem;
    top: 32%;
    height: 1.25rem;
}
</style>
